import type { ReactNode } from 'react';
import {
  DeleteOutlined,
  FileSearchOutlined,
  HeartOutlined,
  ReloadOutlined,
  SendOutlined,
  SettingOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import type { AssetCommandUiId } from './types';

const ICON_PROPS = { 'aria-hidden': true as const };

export function commandIconFor(id: AssetCommandUiId): ReactNode {
  switch (id) {
    case 'Reset':
      return <ReloadOutlined {...ICON_PROPS} />;
    case 'ClearCache':
      return <DeleteOutlined {...ICON_PROPS} />;
    case 'GetLocalListVersion':
      return <UnorderedListOutlined {...ICON_PROPS} />;
    case 'GetConfiguration':
      return <SettingOutlined {...ICON_PROPS} />;
    case 'UpdateHeartbeat':
      return <HeartOutlined {...ICON_PROPS} />;
    case 'TriggerMessage':
      return <SendOutlined {...ICON_PROPS} />;
    case 'GetDiagnostics':
      return <FileSearchOutlined {...ICON_PROPS} />;
  }
}
